export default __webpack_public_path__ + "static/media/50.66f05ac1.jpg";